import { BiIconCross } from '@bi-digital/icons-react';
import { BiButton, BiButtonGroup, BiDialog, BiNotification } from 'bi-web-components-react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

interface ErrorDialogProps {
    onClose: () => void;
    icon: 'warning' | 'information';
    color: 'red' | 'blue' | 'yellow';
    message: string;
    heading: string;
}

export default function ErrorDialog({ onClose, message, heading, icon, color }: ErrorDialogProps) {
    const { t } = useTranslation(['cart', 'common']);

    useEffect(() => {
        // Hack to enable scrolling when dialog is closed
        // Dialog component disables scrolling when opened, but doesn't seem enable it when closed
        const handleClose = () => {
            onClose();
            document.body.style.overflow = '';
        };

        const dialog = document.getElementById('errorDialog');
        dialog?.addEventListener('close', handleClose);
        return () => dialog?.removeEventListener('close', handleClose);
    }, [onClose]);

    return (
        <BiDialog isOpen id='errorDialog' removePadding>
            <BiNotification
                id='errorNotification'
                icon={icon}
                color={color}
                heading={heading}
                message={message}
                hideCloseButton
            >
                <BiButtonGroup alignment='right'>
                    <BiButton
                        variant='text'
                        onClick={() => {
                            onClose();
                            document.body.style.overflow = '';
                        }}
                    >
                        <BiIconCross slot='icon-left' />
                        {t('common:close')}
                    </BiButton>
                </BiButtonGroup>
            </BiNotification>
        </BiDialog>
    );
}
